

function validateValues(values) {

    let errors= {}

   if(values.hasOwnProperty('firstname')){
    if(!values?.firstname?.trim()) {
        errors.firstname = " First Name is required!"
    }else if(!/^[a-zA-Z]*$/.test(values?.firstname)){
          errors.firstname = "Please enter your correct details, only letters are allowed"
    }
   }
    
  if(values.hasOwnProperty('lastname')){
    if(!values?.lastname?.trim()) {
        errors.lastname = " Last Name is required!"
    }else if(!/^[a-zA-Z]*$/.test(values?.lastname)){
        errors.lastname = "Please enter your correct details, only letters are allowed"
    }
  }


  if(values.hasOwnProperty('account_name')){
    if(!values?.account_name?.trim()) {
        errors.account_name = " Account Name is required!"
    }else if(!/^[a-zA-Z]*$/.test(values?.account_name)){
        errors.account_name = "Please enter your correct details, only letters are allowed"
    }
  }
  if(values.hasOwnProperty('name')){
    if(!values?.name?.trim()) {
        errors.name = " Name is required!"
    }else if(!/^[a-z ,.'-]+$/i.test(values?.name)){
        errors.name = "Please enter your correct details, only letters are allowed"
    }
  }

  if(values.hasOwnProperty('phone_number')){
    if(!values?.phone_number?.trim()) {
        errors.phone_number = " A valid Phone Number is required!"
    }else if(!/^[/+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,8}$/.test(values?.phone_number)){
        errors.phone_number = "Please enter a valid phone number"
    }
  }
  if(values.hasOwnProperty('account_number')){
    if(!values?.account_number?.trim()) {
        errors.account_number = " A valid account number is required!"
    }else if(!/^[0-9]/.test(values?.account_number)){
        errors.account_number = "Please enter a valid account number"
    }
  }

  if(values.hasOwnProperty('amount')){
    if(!values?.amount?.trim()) {
        errors.amount = " A valid amount is required!"
    }else if(!/^(?!0,?\d)([0-9]{2}[0-9]{0,})$/.test(values?.amount)){
        errors.amount = "Please enter a valid amount"
    }
  }

    if(values.hasOwnProperty('country')){
        if(!values?.country?.trim()) {
            errors.country = " Country is required!"
        }else if(!/^[a-zA-Z]*$/.test(values?.country)){
            errors.country = "Please enter your correct details, only letters are allowed"
        }
    }
    
    if(values.hasOwnProperty('narration')){
      if(!/^(.{1,100})$/.test(values?.narration)){
            errors.narration = "Not more than 100 characters"
        }
    }

    if(values.hasOwnProperty('email')){
        if(!values?.email?.trim()) {
            errors.email = " Email is required!"
        }else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values?.email)){
            errors.email = "Please enter a valid Email!"
        }
    }

   if(values.hasOwnProperty('username')){
    if(!values?.username?.trim()) {
        errors.username = " Username is required!"
    }else if(!/^(?=[a-zA-Z0-9._]{4,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/.test(values?.username)){
        errors.username = "Username must be 4 to 20 characters long"
    }
   }

    if(values.hasOwnProperty('password')) {
        if(!values?.password?.trim()) {
            errors.password = " Password is required!"
        }else if(values?.password.length < 6){
            errors.password = "Password needs to be 6 characters and above!"
        }
    }

  if(values.hasOwnProperty('confirm_password')){
    if(!values?.confirm_password?.trim()) {
        errors.confirm_password = "Please confirm your Password"
    }else if(values?.password !== values?.confirm_password){
        errors.confirm_password = "Password does not match!"
    }
  }
    if(values.hasOwnProperty('new_password')) {
        if(!values?.new_password?.trim()) {
            errors.new_password = " Password is required!"
        }else if(values?.new_password.length < 6){
            errors.new_password = "Password needs to be 6 characters and above!"
        } else if(values?.new_password === values?.old_password){
            errors.new_password = "Please input a different password from the old one"
        }
    }

  if(values.hasOwnProperty('confirm_new_password')){
    if(!values?.confirm_new_password?.trim()) {
        errors.confirm_new_password = "Please confirm your Password"
    }else if(values?.new_password !== values?.confirm_new_password){
        errors.confirm_new_password = "Password does not match!"
    }
  }

  if(values.hasOwnProperty('old_password')) {
    if(!values?.old_password?.trim()) {
        errors.old_password = " Old Password is required!"
    }else if(values?.old_password.length < 6){
        errors.old_password = "Password needs to be 6 characters and above!"
    }
}

    

  return errors;
}

export default validateValues